module.exports = __webpack_public_path__ + "static/media/green.341c467b.png";